import { render, staticRenderFns } from "./ModalEmpresa.vue?vue&type=template&id=4835df79&scoped=true&"
import script from "./ModalEmpresa.vue?vue&type=script&lang=js&"
export * from "./ModalEmpresa.vue?vue&type=script&lang=js&"
import style0 from "./ModalEmpresa.vue?vue&type=style&index=0&id=4835df79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4835df79",
  null
  
)

export default component.exports